import React from "react";

// Sponsored inventory is a separate, labeled surface. It never receives or
// mutates organic result arrays and is absent while the launch flag is off.
export default function ObserverSponsoredSlot() {
  if (process.env.REACT_APP_SPONSORED_LIVE !== "true") return null;
  return <aside className="ot-sponsored-slot" aria-label="Sponsored practitioner placement"><b>Sponsored</b><p>Paid placement appears in this visually separate slot and never changes the organic results below.</p></aside>;
}
